import React, { useEffect, useRef } from "react";
import { Dialog, DialogContent } from "./dialog";
import { Button } from "./button";
import gsap from "gsap";

const ErrorModal = ({ isOpen, onClose, title, message, onRetry, onMailto }) => {
  const modalRef = useRef(null);
  const iconRef = useRef(null);

  useEffect(() => {
    if (isOpen && modalRef.current && iconRef.current) {
      // Reset animation
      gsap.set(modalRef.current, { 
        scale: 0.8, 
        opacity: 0 
      });
      gsap.set(iconRef.current, { 
        scale: 0, 
        rotation: 180 
      });

      // Animate modal entrance
      const tl = gsap.timeline();
      
      tl.to(modalRef.current, {
        scale: 1,
        opacity: 1,
        duration: 0.3,
        ease: "back.out(1.7)"
      })
      .to(iconRef.current, {
        scale: 1,
        rotation: 0,
        duration: 0.4,
        ease: "back.out(1.7)"
      }, "-=0.1");
    }
  }, [isOpen]);

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent 
        ref={modalRef}
        className="sm:max-w-md mx-auto bg-white dark:bg-neutral-900 border-0 shadow-2xl"
        hideCloseButton
      >
        <div className="flex flex-col items-center justify-center p-6 text-center">
          {/* Error Icon */}
          <div 
            ref={iconRef}
            className="w-16 h-16 mb-4 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center"
          >
            <svg 
              className="w-8 h-8 text-red-600 dark:text-red-400" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>

          {/* Title */}
          <h3 className="text-lg font-semibold text-neutral-900 dark:text-neutral-100 mb-2">
            {title || "Nachricht konnte nicht gesendet werden"}
          </h3>

          {/* Message */}
          <p className="text-sm text-neutral-600 dark:text-neutral-400 leading-relaxed mb-6">
            {message || "Es gab ein technisches Problem beim Versenden Ihrer Nachricht."}
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 w-full">
            {onMailto && (
              <Button
                onClick={onMailto}
                className="flex-1 bg-amber-600 hover:bg-amber-700 text-white"
              >
                E-Mail-Programm öffnen
              </Button>
            )}
            {onRetry && (
              <Button
                onClick={onRetry}
                variant="outline"
                className="flex-1"
              >
                Erneut versuchen
              </Button>
            )}
            <Button
              onClick={onClose}
              variant="ghost"
              className="flex-1"
            >
              Schließen
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export { ErrorModal };
